import { CATEGORIES, SURFACES } from '../../integrations/routes'
import { boolean, float, integer, listOf, rangeListOf, string } from '../../utility/serializers'
import { gettext } from '../../services'
import { binaryId } from './serializers'
import { lngLatType } from '../../integrations/map/serializers'

/**
 * Get all IDs from choices.
 * @param {Object} choices Object of choices
 * @returns {number[]}
 */
const getAllIds = choices => Object.keys(choices).map(id => parseInt(id))

export const ALL_CATEGORIES = getAllIds(CATEGORIES)
export const ALL_SURFACES = getAllIds(SURFACES)

export const DEFAULT_FILTERS = {
    q: '',
    distance: [0, 500],
    ascent: [0, 3000],
    categories: [1, 2, 3],
    surfaces: [1, 2, 3],
    onlyLoop: false,
}

// Min/max values for range filters derive from defaults:
const { distance, ascent } = DEFAULT_FILTERS
export const DISTANCE_FILTER_MIN = distance[0]
export const DISTANCE_FILTER_MAX = distance[1]
export const ASCENT_FILTER_MIN = ascent[0]
export const ASCENT_FILTER_MAX = ascent[1]

/** @type {{key: string, name: string, sort: string, order: "ASC"|"DESC"}[]} */
export const SORT_OPTIONS = [
    { key: 'relevance', name: gettext('Relevance'), sort: 'relevance', order: 'DESC' },
    { key: 'rating', name: gettext('Popularity'), sort: 'rating', order: 'DESC' },
    { key: 'distance-asc', name: gettext('Length'), sort: 'distance', order: 'ASC' },
    { key: 'distance-desc', name: gettext('Length'), sort: 'distance', order: 'DESC' },
    { key: 'ascent-asc', name: gettext('Ascent'), sort: 'ascent', order: 'ASC' },
    { key: 'ascent-desc', name: gettext('Ascent'), sort: 'ascent', order: 'DESC' },
]

/** Minimal number of results */
export const MIN_PAGE_SIZE = 12

/** How many route tiles we have per row when optimizing page size */
export const ROUTE_TILES_PER_ROW = { narrow: 2, wide: 4 }

/** Average height of a route grid item in px */
export const NORMAL_GRID_ITEM_HEIGHT = 270

/** Break point where we switch to a wider grid */
export const COLUMNS_BREAK_POINT = 1440

/** Serializers for URL parameters */
export const URL_PARAMS = {
    q: string,
    page: integer,
    pageSize: integer,
    distance: rangeListOf(integer, DISTANCE_FILTER_MIN, DISTANCE_FILTER_MAX),
    ascent: rangeListOf(integer, ASCENT_FILTER_MIN, ASCENT_FILTER_MAX),
    categories: listOf(binaryId),
    surfaces: listOf(binaryId),
    onlyLoop: boolean,
    sort: string,
    center: lngLatType,
    zoom: float,
    location: integer,
    relativeAscent: rangeListOf(float, 0, 100),
    relativeDescent: rangeListOf(float, 0, 100),
}

/** Serializers for additionally supported legacy URL parameters */
export const SUPPORTED_LEGACY_PARAMS = {
    only_loop: string,
    ascent_min: string,
    ascent_max: string,
    descent_min: string,
    descent_max: string,
    rating_min: integer,
}
